import useLoginStyle from "./useLoginStyle";
import { Grid, Card } from "@material-ui/core";
interface IProps {
  children: any;
}

const LoginLayout = (props: IProps) => {
  const classes = useLoginStyle();

  return (
    <Grid container>
      <Grid
        item
        xl={12}
        lg={12}
        md={12}
        sm={12}
        xs={12}
        className={classes.main}
        style={{
          backgroundImage: `url(${
            process.env.REACT_APP_API_URL?.replace(/\/+$/, "") +
            `/branding/bg_main.png`
          }), url('architecture-1869211_1920.png')`,
        }}
      >
        <Card className={classes.cardNew}>{props.children}</Card>
      </Grid>
    </Grid>
  );
};

export default LoginLayout;
